const INITIAL_STATE = {
  active_hierarchy_module: "user",
};

const hierachyTableSelectReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CHANGE_HIERARCHY_TABLE_TO":
      return {
        ...state,
        active_hierarchy_module: action.payload,
      };

    default:
      return state;
  }
};

export default hierachyTableSelectReducer;
